module.exports = __webpack_public_path__ + "img/try3.908babc5.png";